module.exports = "<div class=\"actions\">\n    <a class=\"btn btn-default\"\n       ng-if=\"$state.includes('r.in.top.orders.list.priority')\"\n       ui-sref=\"r.in.top.orders.list.main\">Open Orders</a>\n    <a class=\"btn btn-default\"\n       ng-if=\"$state.includes('r.in.top.orders.list.main')\"\n       ui-sref=\"r.in.top.orders.list.priority\"\n       permission permission-sref=\"'r.in.top.orders.list.priority'\">Schedule Orders</a></li>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/orders/templates/actions.html
// module id = 642
// module chunks = 0